import moment from 'moment-timezone';

export const getTimezone = () => {
  let timezone = 'America/Los_Angeles';
  if (Intl && Intl.DateTimeFormat) {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  return timezone;
};

export const convertTimeWithTimezone = (
  date,
  timezone = getTimezone(),
  format = 'MM/DD/YYYY - HH:mm z'
) => {
  const formattedTime = moment.tz(date, timezone).format(format);
  return formattedTime;
};

export const processDateRangeQuery = (
  queries,
  dateRangeKey,
  startDateKey,
  endDateKey
) => {
  if (queries[dateRangeKey]) {
    const dates = queries[dateRangeKey].replace(/\s/gi, '').split('-');
    if (dates.length === 2) {
      queries[startDateKey] = convertTimeWithTimezone(
        dates[0],
        undefined,
        'YYYY-MM-DD'
      );
      queries[endDateKey] = convertTimeWithTimezone(
        dates[1],
        undefined,
        'YYYY-MM-DD'
      );
    }
    delete queries[dateRangeKey];
  }
};
